import React from "react";
import "./styles/home.css";
// import homeimg1 from "../images/homeimg1.jpg";

const Home = () => {
  return (
    <div className="home-container">
      {/* Introduction Section */}
      <section className="introduction">
        <h1>Welcome to New Ganesh Bakers</h1>
        <p>
          At <strong>New Ganesh Bakers</strong> , we have been delivering
          freshly baked, high-quality products to our customers since{" "}
          <strong>1989.</strong> <br />
          With a strong focus on{" "}
          <strong>authenticity, taste, and premium ingredients,</strong> we have
          established ourselves as one of
          <strong> Indore’s most trusted bakeries.</strong>
          <br />
          Whether you’re craving a rich chocolate bread cake, a crisp cake rusk,
          or artisanal cookies, we ensure every product meets the highest
          standards of taste and freshness.
        </p>
      </section>

      {/* Image Section */}
      {/* <section className="image-section">
        <div className="image-overlay">
          <img
            src={homeimg1}
            alt="Bakery"
            className="bakery-image"
          />
          <div className="image-text">
            <h2>Experience the Sweetness</h2>
            <p>Our bakery brings joy to every bite.</p>
          </div>
        </div>
      </section> */}

      {/* Why Choose Us Section */}
      <section className="why-choose-us">
        <h2>Why Choose Us?</h2>
        <div className="reasons">
          <div className="reason-item">
            {/* <h3>Fresh Ingredients</h3> */}
            <p>Over 35 years of experience in baking</p>
          </div>
          <div className="reason-item">
            {/* <h3>Handcrafted with Love</h3> */}
            <p> Authentic, homemade-style recipes</p>
          </div>
          <div className="reason-item">
            {/* <h3>Wide Range of Products</h3> */}
            <p>Wide variety of cakes, cookies, and savory items </p>
          </div>
          <div className="reason-item">
            {/* <h3>Wide Range of Products</h3> */}
            <p>High-quality ingredients and strict quality control</p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home;
